module.exports = __webpack_public_path__ + "img/proList2_01.ac473c56.jpg";